
import React from 'react';
import styles from './NavigationDock.module.css';

const NavigationDock = ({ activeTab, onTabChange }) => {
    return (
        <div className={styles.dockContainer}>
            <div className={styles.dockGlass}>
                <button
                    className={`${styles.dockItem} ${activeTab === 'inspector' ? styles.active : ''}`}
                    id="nav-dock-inspector-button"
                    onClick={() => onTabChange('inspector')}
                    aria-label="IP Inspector"
                >
                    <div className={styles.iconWrapper}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
                            <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <circle cx="11" cy="11" r="3" fill="currentColor" fillOpacity="0.3" />
                        </svg>
                    </div>
                    <span className={styles.label}>Inspect</span>
                    {activeTab === 'inspector' && <div className={styles.activeIndicator} />}
                </button>

                <div className={styles.divider} />

                <button
                    className={`${styles.dockItem} ${activeTab === 'plan' ? styles.active : ''}`}
                    id="nav-dock-plan-button"
                    onClick={() => onTabChange('plan')}
                    aria-label="Address Plan"
                >
                    <div className={styles.iconWrapper}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="7" cy="6" r="2" fill="currentColor" />
                            <circle cx="12" cy="12" r="2" fill="currentColor" />
                            <circle cx="17" cy="18" r="2" fill="currentColor" />
                        </svg>
                    </div>
                    <span className={styles.label}>Plan</span>
                    {activeTab === 'plan' && <div className={styles.activeIndicator} />}
                </button>

                <div className={styles.divider} />

                {/* Design agent: Spec 003 — the CIDR/mask/wildcard reference table lives one tap
                    away from the calculators themselves, so a user mid-calculation can check a
                    mask without losing their inspected/plan state. */}
                <button
                    className={`${styles.dockItem} ${activeTab === 'reference' ? styles.active : ''}`}
                    id="nav-dock-reference-button"
                    onClick={() => onTabChange('reference')}
                    aria-label="CIDR Reference Table"
                >
                    <div className={styles.iconWrapper} id="nav-dock-reference-icon-wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id="nav-dock-reference-icon">
                            <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
                            <path d="M3 9H21" stroke="currentColor" strokeWidth="2" />
                            <path d="M9 9V20" stroke="currentColor" strokeWidth="2" />
                        </svg>
                    </div>
                    <span className={styles.label} id="nav-dock-reference-label">Reference</span>
                    {activeTab === 'reference' && <div className={styles.activeIndicator} id="nav-dock-reference-active-indicator" />}
                </button>
            </div>

        </div>
    );
};

export default NavigationDock;
